export default __webpack_public_path__ + "static/media/keenpoint-logo-horizontal-preta.cfab6bd7.png";